import { getParentNode, isType, TEditor } from '@udecode/plate-core';
import { isElement } from 'lodash';
import { ELEMENT_CODE_BLOCK, ELEMENT_CODE_LINE } from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

export const autoFormatQuery = (editor: TEditor) => {
  if (!editor.selection) return false;

  const [parentNode] = getParentNode(editor, editor.selection) || [];

  if (
    !parentNode ||
    !isElement(parentNode) ||
    isType(editor as unknown as DreamEditor, parentNode, ELEMENT_CODE_BLOCK) ||
    isType(editor as unknown as DreamEditor, parentNode, ELEMENT_CODE_LINE)
  ) {
    return false;
  }

  return true;
};
